export const SET_OPORTUNIDADES = "OPORTUNIDADE/SET_OPORTUNIDADES";
export const SET_OPORTUNIDADESLIST = "OPORTUNIDADE/SET_OPORTUNIDADESLIST";
export const SET_OPORTUNIDADE = "OPORTUNIDADE/SET_OPORTUNIDADE";
export const SET_OPORTUNIDADE_ESTATISTICA =
  "OPORTUNIDADE/SET_OPORTUNIDADE_ESTATISTICA";
export const SET_MODELO_CONTRAPARTIDAS =
  "OPORTUNIDADE/SET_MODELO_CONTRAPARTIDAS";
export const SET_PAGINATION = "OPORTUNIDADE/SET_PAGINATION";
export const SET_ODS = "OPORTUNIDADE/SET_ODS";
export const SET_LOADING = "OPORTUNIDADE/SET_LOADING";
